import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";

export function DialogOleo({
    isVisibleOleo, setIsVisibleOleo,
    isVisibleOleoCE, setIsVisibleOleoCE,
    listaOleos, oleo, setOleo,
    salvarOleo, deletarOleo,
}) {
    const abrirNovo = () => {
        setOleo({ id: null, nome: '', validade: null });
        setIsVisibleOleoCE(true);
    };

    const abrirEdicao = (rowData) => {
        setOleo({ ...rowData });
        setIsVisibleOleoCE(true);
    };

    return (
        <>
            {/* Listagem */}
            <Dialog
                header="Óleos Cadastrados"
                onHide={() => setIsVisibleOleo(false)}
                style={{ minWidth: '50vw' }}
                visible={isVisibleOleo}
            >
                <div className="p-fluid">
                    <div className="p-d-flex p-flex-row p-jc-end p-ai-center p-m-1">
                        <Button className="p-m-1" icon="pi pi-plus" onClick={abrirNovo} title="Cadastrar um óleo" />
                    </div>
                    <DataTable
                        value={listaOleos}
                        className="p-m-1"
                        emptyMessage="Nenhum registro lançado até o momento"
                        responsiveLayout="scroll"
                        size="small"
                    >
                        <Column header="Nome / Marca" field="nome" sortable style={{ width: "45%" }} />
                        <Column header="Validade" field="validade" style={{ width: "30%" }}
                            body={(row) => `${row.validade} anos`} />
                        <Column
                            header="Ação"
                            style={{ textAlign: 'center' }}
                            headerStyle={{ display: 'flex', justifyContent: 'center' }}
                            body={(row) => (
                                <div style={{ display: 'flex', gap: 5, justifyContent: 'center' }}>
                                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-text"
                                        onClick={() => abrirEdicao(row)} />
                                    <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => deletarOleo(row)} />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </Dialog>

            {/* Cadastro / Edição */}
            <Dialog
                visible={isVisibleOleoCE}
                style={{ width: '450px' }}
                header={oleo.id ? "Editar Óleo" : "Cadastrar Novo Óleo"}
                modal
                className="p-fluid"
                onHide={() => setIsVisibleOleoCE(false)}
                footer={
                    <div>
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text"
                            onClick={() => setIsVisibleOleoCE(false)} />
                        <Button label="Salvar" icon="pi pi-check" onClick={salvarOleo} autoFocus />
                    </div>
                }
            >
                <div className="p-field p-mt-3">
                    <label htmlFor="nome">Nome / Marca</label>
                    <InputText id="nome" required value={oleo.nome}
                        onChange={(e) => setOleo({ ...oleo, nome: e.target.value })} />
                </div>
                <div className="p-field p-mt-3">
                    <label htmlFor="validade">Validade (em Anos)</label>
                    <InputNumber id="validade" required value={oleo.validade}
                        onValueChange={(e) => setOleo({ ...oleo, validade: e.value })} />
                </div>
            </Dialog>
        </>
    );
}